import MyAccount from 'containers/my-account/MyAccount';
import { FC } from 'react';

const MyAccountPage: FC = () => {
  return <MyAccount />;
};

export default MyAccountPage;
